import { FC, ReactElement, useMemo } from "react";
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core/modules';
import { Colors, DropdownListItem, FlexBox, Dropdown, useIsMobile, useAdvancedLockBodyScroll, ExternalLink } from "@brg/ui";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { useTranslation } from "react-i18next";
import { MoreButton } from "shared/components/more-button";
import { AppTester } from "supporting";

const DropdownWrapper = styled(FlexBox) <{ isTargetEmpty?: boolean }>`
  
  ${({ isTargetEmpty }) => isTargetEmpty
    ? css`
    margin-left: 0px;
  ` : css`
    margin-left: 24px;
  `};

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    ${({ isTargetEmpty }) => isTargetEmpty
    ? css`
    margin-left: 0px;
  ` : css`
    margin-left: 14px;
  `};
  }
`;

const DropdownBodyWrapper = styled.div`
  
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    width: 3px;
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-track {
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }
`;

export const DropdownText = styled(ExternalLink) <{ isActive?: boolean, isMedia?: boolean }>`
  width: 100%;
  font-size: ${({ isMedia }) => isMedia ? '20px' : '17px'};
  line-height: ${({ isMedia }) => isMedia ? '25px' : '22px'};
  letter-spacing: -0.02em;
  font-weight: 600 !important;
  color: ${p => p?.isActive ? p.theme.mainDropdownStyles.colorActive : p.theme.mainDropdownStyles.color} !important;
  
  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 13px;
  }
`;

interface IExternalLinks {
  title: string | (() => string);
  value?: string;
  ctx: string;
  active: boolean;
  external: boolean;
  isModal?: boolean;
  action?: (e?: any) => void;
  isTeam?: boolean;
  name: string;
  disabled?: boolean;
  target?: string;
}

interface IProps {
  target?: { [key: string]: string },
  list: {
    [key: string]: string,
  } | (string | { active: boolean, content: string, linkTo: string })[];
  initialTab?: string;
  hoverOpen?: boolean;
  withExternal?: boolean;
  isDark?: boolean;
}

export const DropdownWithExternalsLinks: FC<{
  target?: ReactElement;
  list: IExternalLinks[];
  initialTab?: string;
  hoverOpen?: boolean;
  maxHeight?: number;
  maxWidth?: number;
  customTarget?: boolean;
  isDarkTheme?: boolean;
  noMargin?: boolean;
  isCustomTitle?: boolean;
  disableLink?: boolean;
}> = ({
  target,
  list,
  hoverOpen,
  maxHeight,
  isDarkTheme = false,
  maxWidth,
  customTarget,
  noMargin,
  isCustomTitle,
  disableLink = false,
}) => {
    const { t } = useTranslation();
    const isDeziiignMain = AppTester.isDeziiignMain();
    const isHseDesign = AppTester.isHSEDesign();
    const isMobile = useIsMobile();

    const targetElem = target || '';
    const [lockBody, unlockBody] = useAdvancedLockBodyScroll();

    const isTargetEmpty = useMemo(() => (targetElem === '' || noMargin), [targetElem, noMargin])

    const dropdownTarget = useMemo(() => {
      return customTarget ? target :
        isDeziiignMain ? (
          <MoreButton />
        ) : (
          <ArrowTopIconWithText
            fill={'#909090'}
            text={''}
          />
        )
    }, [customTarget, isDeziiignMain, target])

    if (!list) {
      return null;
    }

    const items = useMemo(() => {
      return  Array.isArray(list) && list?.map((item, idx) => {
        const {
          title: initialTitle,
          isTeam,
          action,
          external,
          value,
          active,
          disabled,
          target: linkTargetInitial,
        } = item;

        const title = (() => {
          const resolvedTitle = typeof initialTitle === 'function' ? initialTitle() : initialTitle;
          if (typeof resolvedTitle === 'object') {
            return resolvedTitle;
          }
          if (isCustomTitle || isTeam) {
            return resolvedTitle?.toLowerCase();
          }

          return resolvedTitle;
        })();

        const linkTarget = linkTargetInitial || (external ? '_blank' : '_self');
        const tooltipTitle = typeof title === 'string' ? title : undefined;

        return (
          <DropdownListItem
            style={{ cursor: 'pointer' }}
            key={idx}
            justify='space-between'
            isActive={false}
            disabledHover
          >
            <DropdownText
              to={disableLink ? undefined : value}
              target={linkTarget}
              title={tooltipTitle}
              onClick={(ev: any) => {
                if (disabled) {
                  ev.preventDefault();
                }
                if (action) {
                  disabled ? null : action?.(ev);
                }
              }}
            >
              {title}
            </DropdownText>
            <ApprovedIcon fill={Colors.galBlack100} display={active} />
          </DropdownListItem>
        )
      })
    }, [list, disableLink])

    return (
      <DropdownWrapper justify="center" align="center" isTargetEmpty={isTargetEmpty}>
        <Dropdown
          offsetY={12}
          offsetX={isHseDesign ? (isMobile ? -80 : -180) : -100}
          dark={isDarkTheme}
          offsetArrowX={26}
          offsetArrowY={0}
          hideArrow
          hoverOpen={hoverOpen}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          target={dropdownTarget}
        >
          <DropdownBodyWrapper
            onMouseEnter={() => lockBody()}
            onMouseLeave={() => unlockBody(false)}
          >
            {items}
          </DropdownBodyWrapper>
        </Dropdown>
      </DropdownWrapper>
    )
  }
import { FC, ReactElement, useMemo } from "react";
import styled, { css } from 'styled-components';
import { LayoutConst } from 'core/modules';
import { Colors, DropdownListItem, FlexBox, Dropdown, useIsMobile, useAdvancedLockBodyScroll, ExternalLink } from "@brg/ui";
import ArrowTopIconWithText from "shared/icons/ArrowTopIconWithText";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { useTranslation } from "react-i18next";
import { MoreButton } from "shared/components/more-button";
import { AppTester } from "supporting";

const DropdownWrapper = styled(FlexBox) <{ isTargetEmpty?: boolean }>`
  
  ${({ isTargetEmpty }) => isTargetEmpty
    ? css`
    margin-left: 0px;
  ` : css`
    margin-left: 24px;
  `};

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    ${({ isTargetEmpty }) => isTargetEmpty
    ? css`
    margin-left: 0px;
  ` : css`
    margin-left: 14px;
  `};
  }
`;

const DropdownBodyWrapper = styled.div`
  
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    width: 3px;
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.mobileSearch.scroll.body};
  }
  ::-webkit-scrollbar-track {
    background: ${(p) => p.theme.mobileSearch.scroll.background};
  }
`;

export const DropdownText = styled(ExternalLink) <{ isActive?: boolean, isMedia?: boolean }>`
  width: 100%;
  font-size: ${({ isMedia }) => isMedia ? '20px' : '17px'};
  line-height: ${({ isMedia }) => isMedia ? '25px' : '22px'};
  letter-spacing: -0.02em;
  font-weight: 600 !important;
  color: ${p => p?.isActive ? p.theme.mainDropdownStyles.colorActive : p.theme.mainDropdownStyles.color} !important;
  
  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: 15px;
    line-height: 20px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 13px;
  }
`;

interface IExternalLinks {
  title: string | (() => string);
  value?: string;
  ctx: string;
  active: boolean;
  external: boolean;
  isModal?: boolean;
  action?: (e?: any) => void;
  isTeam?: boolean;
  name: string;
  disabled?: boolean;
  target?: string;
}

interface IProps {
  target?: { [key: string]: string },
  list: {
    [key: string]: string,
  } | (string | { active: boolean, content: string, linkTo: string })[];
  initialTab?: string;
  hoverOpen?: boolean;
  withExternal?: boolean;
  isDark?: boolean;
}

export const DropdownWithExternalsLinks: FC<{
  target?: ReactElement;
  list: IExternalLinks[];
  initialTab?: string;
  hoverOpen?: boolean;
  maxHeight?: number;
  maxWidth?: number;
  customTarget?: boolean;
  isDarkTheme?: boolean;
  noMargin?: boolean;
  isCustomTitle?: boolean;
  disableLink?: boolean;
}> = ({
  target,
  list,
  hoverOpen,
  maxHeight,
  isDarkTheme = false,
  maxWidth,
  customTarget,
  noMargin,
  isCustomTitle,
  disableLink = false,
}) => {
    const { t } = useTranslation();
    const isDeziiignMain = AppTester.isDeziiignMain();
    const isHseDesign = AppTester.isHSEDesign();
    const isMobile = useIsMobile();

    const targetElem = target || '';
    const [lockBody, unlockBody] = useAdvancedLockBodyScroll();

    const isTargetEmpty = useMemo(() => (targetElem === '' || noMargin), [targetElem, noMargin])

    const dropdownTarget = useMemo(() => {
      return customTarget ? target :
        isDeziiignMain ? (
          <MoreButton />
        ) : (
          <ArrowTopIconWithText
            fill={'#909090'}
            text={''}
          />
        )
    }, [customTarget, isDeziiignMain, target])

    if (!list) {
      return null;
    }

    const items = useMemo(() => {
      return  Array.isArray(list) && list?.map((item, idx) => {
        const {
          title: initialTitle,
          isTeam,
          action,
          external,
          value,
          active,
          disabled,
          target: linkTargetInitial,
        } = item;

        const title = (() => {
          const resolvedTitle = typeof initialTitle === 'function' ? initialTitle() : initialTitle;
          if (typeof resolvedTitle === 'object') {
            return resolvedTitle;
          }
          if (isCustomTitle || isTeam) {
            return resolvedTitle?.toLowerCase();
          }

          return resolvedTitle;
        })();

        const linkTarget = linkTargetInitial || (external ? '_blank' : '_self');
        const tooltipTitle = typeof title === 'string' ? title : undefined;

        return (
          <DropdownListItem
            style={{ cursor: 'pointer' }}
            key={idx}
            justify='space-between'
            isActive={false}
            disabledHover
          >
            <DropdownText
              to={disableLink ? undefined : value}
              target={linkTarget}
              title={tooltipTitle}
              onClick={(ev: any) => {
                if (disabled) {
                  ev.preventDefault();
                }
                if (action) {
                  disabled ? null : action?.(ev);
                }
              }}
            >
              {title}
            </DropdownText>
            <ApprovedIcon fill={Colors.galBlack100} display={active} />
          </DropdownListItem>
        )
      })
    }, [list, disableLink])

    return (
      <DropdownWrapper justify="center" align="center" isTargetEmpty={isTargetEmpty}>
        <Dropdown
          offsetY={12}
          offsetX={isHseDesign ? (isMobile ? -80 : -180) : -100}
          dark={isDarkTheme}
          offsetArrowX={26}
          offsetArrowY={0}
          hideArrow
          hoverOpen={hoverOpen}
          maxHeight={maxHeight}
          maxWidth={maxWidth}
          target={dropdownTarget}
        >
          <DropdownBodyWrapper
            onMouseEnter={() => lockBody()}
            onMouseLeave={() => unlockBody(false)}
          >
            {items}
          </DropdownBodyWrapper>
        </Dropdown>
      </DropdownWrapper>
    )
  }
